import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditSitemapModal } from '../../-components/SitemapModal';

export const Route = createFileRoute('/_authenticated/sitemaps/$tenantId/nodes/$sitemapNodeId')({
    context: ({ params }) => ({
        sitemapQuery: client.tenant.sitemaps.get.queryOptions(
            {
                params: {
                    sitemapId: Number(params.sitemapNodeId),
                    tenantId: Number(params.tenantId),
                },
            },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.sitemapQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditSitemapModal,
});
